module.exports = __webpack_public_path__ + "img/icon-share.6d9a1225.svg";